// extracted by mini-css-extract-plugin
export var button = "button-module--button--d+uT9";
export var button1 = "button-module--button-1--qdHZz";
export var button2 = "button-module--button-2--ShZVn";
export var button3 = "button-module--button-3--h+z7S";
export var title = "button-module--title--MXfsj";